import {
  ImagesSkusChevronDownSvg,
  ImagesSkusSearchSvg,
} from '@/assets/images_skus.assets';
import DefaultButton from '@/components/common/default/DefaultButton';
import { SkusMobileAlgoliaRefinementListProps } from '@/types/props/components/skus';
import { Checkbox, Field, Label, Transition } from '@headlessui/react';
import Image from 'next/image';
import { Fragment, useEffect, useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import { useRefinementList } from 'react-instantsearch';

export default function SkusMobileAlgoliaRefinementList({
  title,
  attributeName,
}: SkusMobileAlgoliaRefinementListProps) {
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [filteredItems, setFilteredItems] = useState<typeof items>([]);

  const [showFilters, setShowFilters] = useState(false);

  const { items, refine } = useRefinementList({
    attribute: attributeName,
  });

  useEffect(() => {
    setFilteredItems(items);
  }, [items]);

  useEffect(() => {
    setShowSearch(
      Boolean(
        attributeName === 'brand.name' ||
          attributeName === 'brand.region' ||
          attributeName === 'brand.countryOfOrigin' ||
          attributeName === 'subCategory'
      )
    );
  }, [attributeName]);

  function handleSearch(e: React.ChangeEvent<HTMLInputElement>) {
    const searchValue = e.target.value.toLowerCase();
    const filteredItems = items.filter((item) =>
      item.label.toLowerCase().includes(searchValue)
    );
    setFilteredItems(filteredItems);
  }

  return (
    <li>
      <DefaultButton
        className="tw-font-plusJakartaSans !tw-text-base tw-font-semibold tw-text-textBlack tw-flex tw-items-center tw-justify-between tw-w-full"
        onClick={() => setShowFilters((prev) => !prev)}
      >
        {title}
        <Image
          src={ImagesSkusChevronDownSvg}
          width={5.59}
          height={12}
          alt="Chevron Down"
          className={`tw-transition-transform tw-duration-300 ${
            showFilters ? 'tw-rotate-180' : ''
          }`}
        />
      </DefaultButton>

      <Transition
        as={Fragment}
        show={showFilters}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="tw-mt-4 tw-border tw-border-custom-gray tw-border-solid tw-border-r-0 tw-border-l-0 tw-border-t-0 tw-pb-4">
          {showSearch && (
            <div className="tw-mb-4 tw-relative">
              <Image
                src={ImagesSkusSearchSvg}
                width={18.333332061767578}
                height={18.333332061767578}
                alt="Search"
                className="tw-absolute tw-left-2 -tw-translate-y-1/2 tw-top-1/2"
                aria-hidden="true"
              />
              <input
                type="text"
                name="search"
                id="search"
                placeholder={`Search ${title}`}
                className="tw-py-2 tw-bg-white tw-border tw-border-solid tw-border-custom-gray tw-pr-4 tw-pl-8 tw-font-medium tw-text-base tw-text-textBlack tw-rounded-md tw-w-full"
                onChange={handleSearch}
              />
            </div>
          )}
          <div className="tw-mb-4">
            <ul className="tw-space-y-2 tw-p-0">
              {filteredItems.map((item) => (
                <Field
                  as="li"
                  className="tw-flex tw-items-center tw-gap-2"
                  key={item.value}
                >
                  <Checkbox
                    id={`checkbox-country-${item.label}`}
                    name={`checkbox-country-${item.label}`}
                    checked={item.isRefined}
                    onChange={() => {
                      refine(item.value);
                    }}
                    className="tw-group tw-flex tw-size-6 tw-rounded-md tw-border-2 tw-bg-white tw-border-solid tw-border-custom-gray tw-items-center tw-justify-center data-[checked]:tw-bg-main"
                  >
                    <FaCheck className="group-data-[checked]:tw-text-white tw-text-transparent tw-text-xs" />
                  </Checkbox>
                  <Label
                    className="tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-text-text"
                    htmlFor={`checkbox-country-${item.label}`}
                  >
                    {attributeName === 'volumeInPercent'
                      ? `${Number(item.label) / 10}%`
                      : attributeName === 'yearBottled'
                        ? new Date(item.label).toLocaleDateString()
                        : item.label}{' '}
                    <span className="tw-bg-baby-blue tw-font-plusJakartaSans tw-font-medium tw-text-sm tw-text-textBlack tw-rounded-full tw-px-3 tw-py-1">
                      {item.count}
                    </span>
                  </Label>
                </Field>
              ))}
            </ul>
          </div>
        </div>
      </Transition>
    </li>
  );
}
